const loc_cs_strings = {
    "Login": {
        "HEADING": "Přihlášení pomocí MM ID",
        "LOGIN": "Přihlášení",
        "USER": "Uživatel",
        "PASSWORD": "Heslo",
        "LOGIN_FAIL": "Přihlášení se nezdařilo",
        "LOGIN_FIELD_REQUIRED": "„Uživatelské jméno“ je povinné pole",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "FORGOT_PASSWORD": "Zapomenuté heslo?",
        "DIFFERENT_ACCOUNT": "Přihlásit se jiným účtem",
        "NO_ACCOUNT": "Nemáte účet? ",
        "REGISTER": "Registrovat se pomocí MM digital",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte svou podporu."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Akce",
        "CHANGE_PASSWORD_TEXT": "Změnit heslo",
        "MY_APPLICATIONS_TEXT": "Mé aplikace MM",
        "APPLICATIONS_TEXT": "Aplikace MM",
        "USERS_LIST_TEXT": "Správa uživatelů"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Mé aplikace MM",
        "APPLICATIONS_TEXT": "Aplikace MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Uživatelské menu",
        "ACTION_TEXT": "Akce",
        "CHANGE_PASSWORD_TEXT": "Změna hesla",
        "USERS_LIST_TEXT": "Správa uživatelů",
        "USER_GROUPS": "Role"
    },
    "Credentials": {
        "OLD_PASSWORD": "Staré heslo",
        "NEW_PASSWORD": "Nové heslo",
        "CONFIRM_PASSWORD": "Potvrdit heslo",
        "PASS_DO_NOT_MATCH": " Hesla se neshodují",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "OLD_PASSWORD_FIELD_REQUIRED": "„Staré heslo“ je povinné pole",
        "SUCCESS_TEXT": "Heslo bylo úspěšně změněno",
        "HEADING": "Pověření ke změně MM-ID",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Změnit",
        "CANCEL": "Zrušit",
        "PASSWORD_CHANGE_ERROR": "Uložení dat se nezdařilo. Prosím, zkuste to znovu později",
        "PASSWORD_STREIGHT_ERROR": "Heslo musí mít nejméně 10 znaků a obsahovat malé a velké písmeno, speciální znak a číslici",
        "PASSWORD_REQUIREMENTS_TEXT": "Heslo musí splňovat následující požadavky:",
        "LOWERCASE_LETTER_TEXT": "Alespoň jedno písmeno ",
        "UPPERCASE_LETTER_TEXT": "Alespoň jedno velké písmeno",
        "NUMBER_TEXT": "Alespoň jedno číslo",
        "SPECIAL_SYMBOL_TEXT": "Alespoň jeden speciální znak",
        "PASSWORD_LENGTH_TEXT": "Mít délku alespoň 10 znaků",
        "PASSWORD_RESTRICTION_TEXT": "Heslo nesmí obsahovat jméno, příjmení ani uživatelské jméno",
        "CHANGE_PASSWORD_TEXT": "Změnit heslo",
        "ACTION_TEXT": "Akce",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte svou podporu."
    },
    "CreatePassword": {
        "PASSWORD": "Vytvořit heslo",
        "CONFIRM_PASSWORD": "Potvrďte své heslo",
        "PASS_DO_NOT_MATCH": "Hesla se neshodují",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "SUCCESS_TEXT": "Data byla úspěšně uložena",
        "HEADING": "Vytvořit heslo",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Změnit",
        "CANCEL": "Zrušit",
        "PASSWORD_CHANGE_ERROR": "Uložení dat se nezdařilo Prosím, zkuste to znovu později",
        "PASSWORD_STREIGHT_ERROR": "Heslo musí mít nejméně 10 znaků a obsahovat malé a velké písmeno, speciální znak a číslici",
        "PASSWORD_REQUIREMENTS_TEXT": "Heslo musí splňovat následující požadavky:",
        "LOWERCASE_LETTER_TEXT": "Alespoň jedno písmeno",
        "UPPERCASE_LETTER_TEXT": "Alespoň jedno velké písmeno",
        "NUMBER_TEXT": "Alespoň jedno číslo",
        "SPECIAL_SYMBOL_TEXT": "Alespoň jeden speciální znak",
        "PASSWORD_LENGTH_TEXT": "Mít délku alespoň 10 znaků",
        "PASSWORD_RESTRICTION_TEXT": "Heslo nesmí obsahovat jméno, příjmení ani uživatelské jméno",
        "PASSWORD_WAS_SET": "Tento odkaz už byl pro nastavení hesla použit. Pokud si heslo nepamatujete, použijte prosím funkci resetovat heslo.",
        "OLD_PASSWORD_REQUIRED": "„Staré heslo“ je povinné pole",
        "MMID_CHANGE_PASSWORD": "Změnit heslo",
        "OLD_PASSWORD": "Staré heslo",
        "INVALID_OLD_PASSWORD": "Neplatné staré heslo",
        "USER_NOT_FOUND_OR_INACTIVE": "Uživatel nenalezen nebo je neaktivní",
        "UNKNOWN_ERROR": "Při změně hesla došlo k chybě"
    },
    "ForgotPassword": {
        "USER": "Email",
        "LOGIN_FAIL": "Prosím zadejte správnou emailovou adresu",
        "LOGIN_FIELD_REQUIRED": "„Email“ je povinné pole",
        "HEADING": "Zapomenuté heslo",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Zaslat email pro resetování hesla",
        "CANCEL": "Zrušit",
        "SUCCESS_TEXT": "Prosím zkontrolujte, zda máte v přijaté poště novou zprávu.",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte podporu.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkce resetovat heslo byla použita příliš mnohokrát, prosím zkuste to znovu později",
        "RESET_FAILED": "Přihlášení se nezdařilo",
        "LINK_EXPIRED": "Váš přihlašovací odkaz vypršel. Pro zaslání přihlašovacího odkazu zadejte znovu svou emailovou adresu.",
        "HEADING_EXPIRED": "Váš přihlašovací odkaz vypršel",
        "SAVE_EXPIRED": "Vyžádat přihlašovací odkaz"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Správa uživatelů",
        "ACTIVE": "Aktivní",
        "INACTIVE": "Neaktivní",
        "MMID": "MMID",
        "EXTRANET": "Externí uživatelé",
        "OU": "Organizační jednotka",
        "ORGANIZATION_UNIT": "Organizační jednotka",
        "LANGUAGE": "Jazyk",
        "OPEN_FILTER": "Otevřít filtr",
        "CLOSE_FILTER": "Zavřít filtr",
        "RESET": "resetovat",
        "RESET_ALL_FILTERS": "Resetovat všechny filtry",
        "SEARCH": "Hledat",
        "STATUS": "Stav",
        "GROUPS": "Skupiny",
        "SHOW_ALL_DETAILS": "Zobrazit všechny detaily",
        "SHOW_LESS": "Zobrazit méně",
        "ASCENDING": "Vzestupně",
        "DESCENDING": "Sestupně",
        "LIST_END": "Konec seznamu",
        "SORT_BY_LASTNAME": "Seřadit podle příjmení",
        "SORT_BY_FIRSTNAME": "Seřadit podle jména",
        "SORT_BY_EMAIL": "Seřadit podle emailu",
        "SORT_BY_LANGUAGE": "Seřadit podle preferovaného jazyka",
        "SORT_BY_STATUS": "Seřadit podle stavu",
        "SORT_BY_OU": "Seřadit podle OJ",
        "EDIT": "Editovat",
        "CREATE": "Nový uživatel",
        "DIGICREATE": "Nový uživatel MM digital",
        "EXTRANETCREATE": "Nový uživatel MM SharePoint z extranetu",
        "ACTIVATE": "Aktivovat",
        "DEACTIVATE": "Deaktivovat",
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "SEND_FORGOT_PW_EMAIL": "Zaslat email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Obecný email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Email při zapomenutí hesla MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Email při zapomenutí hesla SP",
        "COMPANY": "Společnost",
        "SEND_WELCOME_EMAIL": "Zaslat uvítací email",
        "SEND_WELCOME_EMAIL_DIGI": "Uvítací email MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Uvítací email MM digital bez tlačítka Heslo",
        "SEND_WELCOME_EMAIL_EXTRANET": "Uvítací email SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Uvítací email SP bez tlačítka Heslo",
        "APPLY_FILTER_FOR_USERS": "K zobrazení výsledků použijte filtry nebo hledání",
        "GENERATING_EMAIL": "Vytváří se email....",
        "ERROR_EMAIL_GENERATE": "Chyba při vytváření emailu....",
        "SORT_BY_ACCOUNT_NAME": "Seřadit podle přihlašovacího jména",
        "LOCKED": "Uzamčeno",
        "UNLOCK": "Odemknout",
        "SET_PASSWORD": "Nastavit heslo",
        "PHYSICAL_LOCATION": "Umístění",
        "REQUIRED": "Požadováno",
        "MMPCREATE": "Nový uživatel MMP digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Email při zapomenutí hesla MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Uvítací email MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Uvítací email MMP digital bez tlačítka Heslo",
        "USER_TYPE": "Typ uživatele",
        "CANONICAL_NAME": "Obecný název"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Správa uživatelů",
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "LOADING_USER_ERROR": "Chyba při načítání uživatele",
        "FIRSTNAME": "Jméno",
        "LASTNAME": "Příjmení",
        "EMAIL": "Email",
        "ACCOUNT_NAME": "Přihlašovací jméno uživatele (před Windows 2000)",
        "LANGUAGE": "Jazyk",
        "PRINCIPAL_NAME": "Hlavní jméno uživatele (UPN)",
        "OU": "Organizační jednotka",
        "CLASS_DISPLAY_NAME": "Zobrazené jméno",
        "PHONE": "Telefon",
        "WEBSITE": "Webové stránky",
        "COUNTRY": "Země",
        "STATE": "Stát",
        "LOCATION": "Město",
        "STREET": "Ulice",
        "POSTAL_CODE": "PSČ",
        "COMPANY": "Společnost",
        "DEPARTMENT": "Oddělení",
        "PERSONAL_TITLE": "Oslovení",
        "MANAGER": "Manažer",
        "DESCRIPTION": "Popis",
        "GROUPS": "Skupiny",
        "SAVE": "Uložit",
        "CANCEL": "Zrušit",
        "USER_STATUS": "Stav uživatele",
        "ACTIVE": "Aktivní",
        "INACTIVE": "Neaktivní",
        "ACTIVATE": "Aktivovat",
        "DEACTIVATE": "Deaktivovat",
        "USER_WAS_SAVED": "Uživatel byl uložen. Aktualizace serverů může trvat až 60 sekund<br/> Pokud se vám zobrazují stará data, aktualizujte stránku vždy po 30 sekundách.",
        "UNKNOWN_ERROR": "Při ukládání uživatele došlo k neznámé chybě",
        "PROXY_ADDRESSES": "Proxy adresy",
        "BROWSE": "Procházet",
        "REMOVE": "Odstranit",
        "ONLY_JPG": "Jsou dovoleny pouze obrázky ve formátu jpg!",
        "FILE_SIZE": "Soubor musí být menší než 100 kB!",
        "DIMENSIONS": "Maximální velikost obrázku je 96x96 pixelů!",
        "SEND_FORGOT_PW_EMAIL": "Zaslat email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Obecný email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Email při zapomenutí hesla MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Email při zapomenutí hesla SP",
        "VIRUS_FOUND": "Uložení uživatele se nezdařilo. V příloze byl nalezen malware. Soubor nebude načten. Kontaktujte svého systémového administrátora.",
        "VIRUS_SCANNER_NOT_AVL": "Soubor nemohl být prověřen na přítomnost malware. Prosím, zkuste to znovu později. Pokud problém přetrvává, kontaktujte svého systémového administrátora.",
        "INFO": "Informace:",
        "SEND_WELCOME_EMAIL": "Zaslat uvítací email",
        "SEND_WELCOME_EMAIL_DIGI": "Uvítací email MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Uvítací email MM digital bez tlačítka Heslo",
        "SEND_WELCOME_EMAIL_EXTRANET": "Uvítací email SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Uvítací email SP bez tlačítka Heslo",
        "SAVING_USER_SPINNER": "Ukládání uživatele... Čekejte, prosím",
        "DUPLICATE_USER": "Uživatel již existuje",
        "GENERATING_EMAIL": "Vytváří se email....",
        "ERROR_EMAIL_GENERATE": "Chyba při vytváření emailu....",
        "UNLOCK": "Odemknout",
        "SET_PASSWORD": "Nastavit heslo",
        "COST_CENTER": "Nákladové středisko",
        "JOB_TITLE": "Pracovní pozice",
        "GENDER": "Pohlaví",
        "SEND_FORGOT_PW_EMAIL_MMP": "Email při zapomenutí hesla MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Uvítací email MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Uvítací email MMP digital bez tlačítka Heslo",
        "USER_NOT_FOUND": "Uživatel nenalezen",
        "USER_TYPE": "Typ uživatele",
        "CANONICAL_NAME": "Obecný název"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "EMAIL_WAS_SENT": "Email byl úspěšně odeslán",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Email nebyl odeslán Uživatel už je aktivní. Použijte raději funkci Zaslat email při zapomenutí hesla",
        "ERROR_EMAIL_SEND": "Chyba při odesílání emailu",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Email nebyl odeslán. Uživatel je neaktivní. Použijte funkci Zaslat registrační email MM digital.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkce resetování hesla byla použita příliš mnohokrát, prosím, zkuste to znovu později",
        "USER_WAS_UNLOCKED": "Uživatel byl odemknut",
        "ERROR_UNLOCK_USER": "Chyba při odemykání uživatele"
    },
    "Backend": {
        "FieldRequired": "Toto pole je povinné.",
        "FirstName": "Jméno",
        "InvalidEmail": "Prosím zadejte správnou emailovou adresu",
        "InvalidPhone": "Neplatné telefonní číslo.",
        "LastName": "Příjmení",
        "StringLength": "Pole musí být řetězec o minimální délce {2} a maximální délce {1}."
    },
    "Emails": {
        "Header": "Váš účet pro aplikaci {{var-app-name}}",
        "Welcome": "Vítejte v aplikaci {{var-app-name}}",
        "HelloLine": "Vážený/á {{var-salutation}} {{var-first-name}} {{var-last-name}}",
        "AccountCreatedLine": "Váš účet pro aplikaci {{var-app-name}} byl úspěšně vytvořen. Pro dokončení aktivace ověřte svou emailovou adresu kliknutím na následující tlačítko:",
        "Login": "Přihlásit se",
        "SingInLink": "K přihlášení můžete v budoucnu použít následující odkaz:",
        "AccountDetails": "Údaje o Vašem účtu:",
        "Email": "Email",
        "FristName": "Jméno",
        "LastName": "Příjmení",
        "SupportAssist": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže.",
        "BestRegards": "Se srdečným pozdravem,<br/> Váš {{var-app-name-2}} tým",
        "ContactSupport": "Kontaktovat podporu",
        "ForgotPassword": "Zapomenuté heslo",
        "PleaseResetPassword": "Prosím, resetujte své heslo pro {{var-app-name}}",
        "ResetPasswordLine": "Heslo svého účtu {{var-app-name}} můžete resetovat během následujících 24 hodin kliknutím na následující tlačítko:",
        "ResetPassword": "Resetovat heslo",
        "IgnoreEmailLine": "V případě, že si nepřejete resetovat heslo, ignorujte tento email.",
        "ResendWelcome1": "Tento přihlašovací odkaz platí 5 dnů:",
        "ResendWelcome2": "Znovu vyžádat přihlašovací odkaz",
        "ContactSupportMMK": "Kontaktujte podporu MM digital",
        "AccountCreatedLine_NoButton": "Váš {{var-app-name}} účet byl úspěšně vytvořen.",
        "ContactSupportMMP": "Kontaktujte podporu MMP digital",
        "CreateUserSubject": "Vítejte v aplikaci {{var-app-name}}",
        "ForgotPasswordSubject": "{{var-app-name}}: Resetovat heslo",
        "SupportAssistMMP": "V případě dotazů se obraťte přímo na svého místně příslušného obchodního partnera. V případě technických potíží se můžete spojit s týmem podpory {{var-app-name}} na <a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-support-email}}</a>",
        "SupportAssistMMK": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže.",
        "SupportAssistSharepoint": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže."
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Vytváří se uvítací email...."
    }
};

export default loc_cs_strings;



// WEBPACK FOOTER //
// ./src/resources/cs.js